import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from "components/app/dialog/dialog";
import { Button } from "components/ui/button";
import { ScrollArea, ScrollBar } from "components/ui/scroll-area";
import { X } from "lucide-react";
import { useEffect, useState } from "react";

interface DialogProps {
  categories: any;
  onValueChange: (value: any) => void;
  isDialogOpen: boolean;
  setIsDialogOpen: (value: boolean) => void;
  value: string;
}

interface ItemGroup {
  id: number;
  shop_group: string;
  code: string;
}

export default function DailogCategories({
  categories,
  isDialogOpen,
  setIsDialogOpen,
  onValueChange,
  value,
}: DialogProps) {
  const [itemGroups, setItemGroups] = useState<any[]>(categories);
  const [textInput, setTextInput] = useState<string>(value);

  const handleSave = () => {
    if (textInput !== categories) {
      onValueChange(textInput);
    }
    setIsDialogOpen(false);
  };

  const groupedByCategory: Record<string, ItemGroup[]> = itemGroups?.reduce(
    (acc: Record<string, ItemGroup[]>, group: ItemGroup) => {
      const category = group.shop_group || "Uncategorized";
      if (!acc[category]) {
        acc[category] = [];
      }
      acc[category].push(group);
      return acc;
    },
    {}
  );

  // Set default selected value when the component mounts
  useEffect(() => {
    if (value) {
      setTextInput(value?.toString() || ""); // Set default value to first group code
    }
  }, [value]);

  return (
    <Dialog open={isDialogOpen}>
      <DialogContent
        isShowBtnXClose={false}
        className="custom-dialog-class flex flex-col justify-between"
      >
        <DialogHeader>
          <DialogTitle>Categories</DialogTitle>
          <DialogDescription>
            Make changes to your profile here. Click save when you're done.
          </DialogDescription>
          <div
            className="absolute flex items-center justify-center right-4 top-1 z-40 cursor-pointer rounded-full bg-gray-200 dark:bg-accent w-[28px] h-[28px]"
            onClick={() => setIsDialogOpen(false)}
          >
            <X />
          </div>
        </DialogHeader>
        <ScrollArea className="mt-2 w-full h-[400px]">
          {Object.entries(groupedByCategory || {}).map(([category, groups]) => (
            <div key={category} className="mb-2">
              <h3 className="font-bold">{category}</h3>
              <div className="flex flex-wrap">
                {groups.map((group) => {
                  const isSelected = textInput === group?.code.toString();
                  return (
                    <div
                      key={group.id || group.code} // Ensure a unique key
                      className={`p-1 border rounded-xl px-2 mr-2 cursor-pointer font-semibold mt-2 ${
                        isSelected
                          ? "bg-blue-500 text-white"
                          : "bg-white text-black"
                      }`}
                      onClick={() => {
                        setTextInput(group?.code.toString());
                      }}
                    >
                      <p className="text-nowrap text-sm">{group?.code}</p>
                    </div>
                  );
                })}
              </div>
            </div>
          ))}

          <ScrollBar orientation="vertical" />
        </ScrollArea>
        <DialogFooter>
          <Button
            className="bg-destructive text-white bg-blue-600 hover:bg-blue-500"
            onClick={handleSave}
          >
            Save
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
